import { render, staticRenderFns } from "./DetailsCardPriceIncludes.vue?vue&type=template&id=4b2dc41e&scoped=true&"
import script from "./DetailsCardPriceIncludes.vue?vue&type=script&lang=js&"
export * from "./DetailsCardPriceIncludes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2dc41e",
  null
  
)

/* custom blocks */
import block0 from "./DetailsCardPriceIncludes.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSpacer})
